var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.imageUrl)?_c('b-card',{staticClass:"p-2 calllog-details booking_details text-center"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.imageUrl}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }